import { DocumentTextIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { cn } from '@/lib/utils';

interface SubNavItem {
  name: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  current?: boolean;
}

interface PostgridSubNavigationProps {
  className?: string;
}

/**
 * PostGrid sub-navigation component with Mail and Contacts tabs
 */
export const PostgridSubNavigation: React.FC<PostgridSubNavigationProps> = ({
  className,
}) => {
  const location = useLocation();

  const navigation: SubNavItem[] = [
    {
      name: 'Mail',
      href: '/postgrid',
      icon: DocumentTextIcon,
      current:
        location.pathname === '/postgrid' ||
        location.pathname === '/postgrid/dashboard',
    },
    {
      name: 'Contacts',
      href: '/postgrid/contacts',
      icon: UserGroupIcon,
      current:
        location.pathname.startsWith('/postgrid/contacts') ||
        location.pathname === '/postgrid/create-contact',
    },
  ];

  return (
    <div className={cn('border-b border-gray-200', className)}>
      <nav className="flex space-x-8" aria-label="PostGrid Navigation">
        {navigation.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                item.current
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                'flex items-center gap-2 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium transition-colors',
              )}
              aria-current={item.current ? 'page' : undefined}
            >
              <Icon className="h-4 w-4" />
              {item.name}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};
